export default "__VITE_ASSET__NzE_AwZb__"